import React, { useState } from 'react'
import FollowingTabs from '../../components/followingTab/FollowingTabs';
import SubscribedTab from '../../components/subscribedTab/SubscribedTab';
import RequestsTab from '../../components/requestsTab/RequestsTab';
import '../following/Following.css'

const Following = () => { 
  const [activeTab, setActiveTab] = useState(0); // Tracks the active tab
  return (
    
    <div className='dashboard-content-box'>
      <div className="tabs-container following-sec">
        <div className='innerfollowing-sec'>
          <div className="tabs-header d-flex flex-wrap justify-content-center align-content-center">
            <button className={`tab-button ${activeTab === 0 ? "active" : ""}`} onClick={() => setActiveTab(0)}> Following </button>
            <button className={`tab-button ${activeTab === 1 ? "active" : ""}`} onClick={() => setActiveTab(1)}> Subscribed </button>
            <button className={`tab-button ${activeTab === 2 ? "active" : ""}`} onClick={() => setActiveTab(2)}> Requests </button>
          </div>
          <div className='search-section-following'>
            <div className='search-box'>
              <div className="search-container">
                <form action="">
                  <div className='form-search-box'>
                    <button type="submit">
                      <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3418 19.25C16.1512 19.25 20.0501 15.3512 20.0501 10.5417C20.0501 5.7322 16.1512 1.83334 11.3418 1.83334C6.53228 1.83334 2.63342 5.7322 2.63342 10.5417C2.63342 15.3512 6.53228 19.25 11.3418 19.25Z" stroke="#787486" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.9668 20.1667L19.1334 18.3333" stroke="#787486" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </button>
                    <input type="search" placeholder="Search.." name="" />
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="tabs-content">
            {activeTab === 0 && (
                <div className="tab-panel">
                    <FollowingTabs />
                </div>
            )}
            {activeTab === 1 && (
                <div className="tab-panel">
                   <SubscribedTab />
                </div>
            )}
            {activeTab === 2 && (
                <div className="tab-panel">
                   <RequestsTab />
                </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Following
